import urls from '@/constants/endpoints/gateway';
import {CallbackRequestCountDTO, CallBellLogsDTO} from '@/types/gatewayDataModels';

import httpApi from './httpApi_new';

class CallBellLogsService {
    getCallBellLogs = (): Promise<CallBellLogsDTO> =>
        httpApi.get({
            url: urls.GET_CALL_BELL_LOGS,
        });

    resolveCallbackRequest = ({callbackRequestId}: {callbackRequestId: number}) =>
        httpApi.post({
            url: urls.RESOLVE_CALLBACK_REQUEST(callbackRequestId),
        });
    getMissedCallBellLogsCount = (): Promise<CallbackRequestCountDTO> =>
        httpApi.get({
            url: urls.GET_MISSED_CALL_BELL_LOGS_COUNT,
        });
}

const callBellLogsService = new CallBellLogsService();
export default callBellLogsService;
